import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Box, Flex } from '@lightspeed/flame/Core';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { IconVerified } from '@lightspeed/flame/Icon/Verified';
import { IconWarning } from '@lightspeed/flame/Icon/Warning';
import { InputGroup } from '@lightspeed/flame/InputGroup';
import { Spinner } from '@lightspeed/flame/Spinner';
import { Text } from '@lightspeed/flame/Text';

import { BarcodeSyncStatus } from 'root/apps/InventoryCountScanQueue/BarcodeService';

import { ScanDataContext } from '../context/ScanData';
import { ScanStatus } from '../types';

interface RowProps {
  title: string;
  status: BarcodeSyncStatus;
  count: number;
}

export const TitleRow: React.FC<RowProps> = ({ title, status, count }) => {
  const { purgeByStatus, updateCollections } = React.useContext(ScanDataContext);

  const handleClearSection = (status: BarcodeSyncStatus) => {
    purgeByStatus(status).then(() => {
      updateCollections();
    });
  };

  return (
    <Box
      px={4}
      m={0}
      height={48}
      backgroundColor={theme.colors['gray-50']}
      data-test={`scan-queue-list-title-${status}`}
    >
      <Flex flexDirection="row" justifyContent="space-between" alignItems="center" height="100%">
        <Flex alignItems="center">
          {status === ScanStatus.Done ? (
            <IconVerified
              size="14px"
              baseColor1={theme.colors.primary}
              data-test="scan-queue-icon-verified"
            />
          ) : null}
          {status === ScanStatus.Failed ? (
            <IconWarning
              size="14px"
              baseColor1={theme.colors.danger}
              data-test="scan-queue-icon-warning"
            />
          ) : null}
          {status === ScanStatus.Pending ? (
            <Spinner
              size="14px"
              baseColor1={theme.colors.secondary}
              data-test="scan-queue-spinner"
            />
          ) : null}
          <Text
            paddingX={1}
            fontSize={12}
            textTransform="uppercase"
            fontWeight="bold"
            letterSpacing={2}
            data-test={`scan-queue-list-title-text-${status}`}
          >
            {title}
          </Text>
          {count >= 1 ? (
            <Text fontSize={12}>
              <var className="notranslate">{count}</var> {` ${count > 1 ? 'items' : 'item'}`}
            </Text>
          ) : null}
        </Flex>
        {status === ScanStatus.Failed ? (
          <InputGroup>
            <Button
              data-test="scan-queue-clear-section-failed-btn"
              disabled={!(count > 0)}
              onClick={() => handleClearSection(status)}
            >
              <Text fontSize={14}>Clear section</Text>
            </Button>
          </InputGroup>
        ) : null}
        {status === ScanStatus.Done ? (
          <Button
            disabled={!count}
            data-test="scan-queue-clear-section-done-btn"
            onClick={() => handleClearSection(status)}
          >
            <Text fontSize={14}>Clear section</Text>
          </Button>
        ) : null}
      </Flex>
    </Box>
  );
};
